import { ButtonTs } from '@lt/components';
import { ArrowDown } from '@lt/components/icons-react';
import type { ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';
import { TEST_ID_SORT_BTN } from './constants';

type Props = {
  onClick: () => void;
  children: ReactNode;
  className?: string;
};

export const ShowSortingButton = ({ children, onClick, className }: Props) => (
  <StyledButton
    onClick={onClick}
    data-testid={TEST_ID_SORT_BTN}
    className={className}
  >
    {children}
    <StyledArrowDown />
  </StyledButton>
);

const StyledButton = styled(ButtonTs).attrs({ variant: 'functional' })`
  padding: 12px;
  background-color: #e6e9ee;
  border-radius: 12px;

  transition: 0.1s ease-in-out;

  white-space: pre;

  &:active {
    background: #b5b5b5;
  }
`;

const StyledArrowDown = styled(ArrowDown)`
  stroke-width: 0;
  margin-left: 6px;
  width: 12px;
  height: 10px;
  transform: rotate(180deg);

  > path {
    fill: black;
  }
`;
